module.exports = __webpack_public_path__ + "img/logo_5A.d9743212.png";